var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('p',[_vm._v("Amalgama digital, inc.")]),_c('p',[_vm._v("244 Fifth Avenue, Suite A240")]),_c('p',[_vm._v("New York, NY 10001")])])
}]

export { render, staticRenderFns }